import React from 'react';
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useLocalization } from "gatsby-theme-i18n";

const Program = ({ slot, title, time, id, type, isLive, onMouseEnter, onClick }) => {

  
  const { t } = useLocalization();

  return (
    <ProgramWrapper className={`${type} ${isLive ? 'live' : ''}`}>
      <SlotLabel>
        {slot}
        <LiveLabel>{t('program_timetable.day1.live.badge')}</LiveLabel>
      </SlotLabel>
      <InformationCard href="#" type={type} onMouseEnter={onMouseEnter} onClick={onClick}>
        <span className="plus"></span>
        <TimeLabel>{time}</TimeLabel>
        <TitleLabel>{title}</TitleLabel>
      </InformationCard>
    </ProgramWrapper>
  );
}

const InfoContent = (props) => {
  
  const {type, children} = props
  if(type === "stage")
    return (<a {...props}>{children}</a>);
  else
    return (<span {...props}>{children}</span>);
}
 
export default Program;


const ProgramWrapper = styled.div`
  display:flex;
  margin-bottom:16px;
  position:relative;
  overflow:visible;
  padding:0 28px 0 0;
  text-align:left;

  &:last-of-type{
    margin-bottom:0;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .streaming &{
      padding:0;
      margin-bottom:8px;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0;
    padding-left: 0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
    padding-left:0;
    margin-bottom:6px;
    
    
  }
`

const SlotLabel = styled.div`
  color: #ADADAF;
  font-size: 24px;
  line-height: 24px;
  padding:20px 24px 20px 0;
  font-weight: 900;
  position:relative;
  white-space: nowrap;

  .streaming &{
    font-size: 20px;
    line-height: 24px;
    padding:16px 32px 16px 0;
  }

  .live &{
    color: #4E4E50;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:16px 48px 16px 0;
    font-size: 20px;
    line-height: 24px;
    .streaming &{
      padding:16px 48px 16px 0;
      font-size: 20px;
      line-height: 24px;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 16px;
    line-height: 30px;
    padding:0;
    margin-bottom:4px;
    .streaming &{
      padding:0;
      font-size: 16px;
      line-height: 30px;
      margin-bottom:4px;
    }
  
  }
`

const InformationCard = styled(InfoContent)`
  display:block;
  background: #ECECEF;
  border: 1px solid #CACACD;
  box-sizing: border-box;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding:24px;
  width:416px;
  position:relative;
  text-decoration:none;
  

  .stage &{
    background: #FCFCFF;
    border: 1px solid #ECECEF;
    transition: border-color .3s;

    .plus{
      position:absolute;
      display:block;
      width:32px;
      height:32px;
      top:24px;
      right:24px;
      opacity:0;
      transition: opacity .3s;

      &:before,&:after{
        content:' ';
        position:absolute;
        top:50%;
        left:50%;
        transform:translateX(-50%);
        width:22px;
        height:2px;
        background:#ADADAF;
        display:block;
        transition: background .3s;
      }
      &:after{
        transform:translateX(-50%) rotate(90deg);
      }
    }

    &:hover{
      border-color:#ADADAF;
      .plus{
        opacity:1;
      }
    }
    &:active{
      border-color:#4E4E50;
      .plus{
        opacity:1;
        &:before,&:after{
          background:#4E4E50
        }
      }
    }
    
  }

  .live &{
    border-color:#D00F31 !important
  }

  .streaming &{
    padding:16px;
    
  }
  
  .streaming .stage &{
    .plus{
      width:24px;
      height:24px; 
      top:16px;
      right:16px;

      &:before,&:after{
        width:20px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    padding:16px;

    .stage &{
      .plus{
        top:16px;
        right:16px;
        width:24px;
        height:24px;
        &:before,&:after{
          width:15px;
        }
      }
    }
    .streaming &{
      width:100%;
      padding:16px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:12px;

    .stage &{
      .plus{
        top:12px;
        right:12px;
      }
    }

    .streaming &{
      padding:12px;
    }
  }
`

const LiveLabel = styled.div`
  display:none;
  position:absolute;
  font-size: 10px;
  line-height: 12px;
  color: #FCFCFF;
  letter-spacing: 0.03em;
  background: #EF2F51;
  border-radius: 3px;
  padding:2px 4px;
  font-weight: 900;
  right: 24px;
  top: 0;

  .live &{
    display:block;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .streaming &{
      right:32px;
      top:0;
    }
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    right: 48px;
    top: 0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    position:relative;
    top:auto;
    right:auto;
    margin-left:16px;
    vertical-align:middle;
    margin-bottom:2px;
    .live &{
      display:inline-block;
    }
  }
`

const TimeLabel = styled.span`
  display:inline-block;
  font-size: 16px;
  line-height: 24px;
  color: #787880;
  margin-right:16px;
  font-weight: 900;

  .stage &{
    display:block;
    color: #D00F31;
    margin-right:48px;
  }

  .streaming &{
    font-size: 14px;
    line-height: 24px;
    margin-right:0px;
  }

  .streaming .stage &{
    margin-right:40px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
    .stage &{
      margin-right:40px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
    .stage &{
      margin-right:40px;
    }
  }
`

const TitleLabel = styled.span`
  display:inline-block;
  font-size: 16px;
  line-height: 24px;
  color: #787880;
  font-weight: 900;

  .stage &{
    font-size: 20px;
    line-height: 32px;
    color: #2C2C2E;
    margin-right:48px;
  }

  .streaming &{
    font-size: 14px;
    line-height: 24px;
    margin-right:0;
    
  }

  .streaming .stage &{
    font-size: 16px;
    line-height: 28px;
    margin-right:40px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
    .stage &{
      font-size: 16px;
      line-height: 28px;
      margin-right:40px;
    }
    .streaming &{
      font-size: 14px;
      line-height: 24px;
    }
    .streaming .stage &{
      font-size: 16px;
      line-height: 28px;
      margin-right:40px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
    .stage &{
      font-size: 14px;
      line-height: 24px;
      margin-right:40px;
    }

    .streaming &{
      font-size: 12px;
      line-height: 20px;
    }
    .streaming .stage &{
      font-size: 14px;
      line-height: 24px;
      margin-right:40px;
    }
  }
`
